import { observable } from 'mobx';

const ADOBA_REPORT = observable({
    DATA: "",
})

export { ADOBA_REPORT }